<script lang="ts">
  import { Row, Col, Button } from 'svelte-materialify';
  import type { CategoryConfig } from '../../modules/projects/project.interface';
  import type { Item } from '../../modules/item/item.interface';
  import ItemPreview from './ItemPreview.svelte';
  import { ItemStatus } from '../../modules/item/item.constants';
  import { createEventDispatcher } from 'svelte';
  import { report } from '../../store';
  import { ItemService, ReportService } from '../../modules';
  import Files from '../../lib/files';

  export let item: Item;
  export let oldItem: Item;
  export let categoryConfig: CategoryConfig;

  const dispatch = createEventDispatcher();

  const files = new Files();

  async function validatedEvent(eventType: string, status: ItemStatus) {
    item.status = status;

    dispatch(eventType, { item, files });
  }

  async function addReport(item, status: ItemStatus) {
    try {
      await ItemService.updateStatus(item.id, status, $report.date);
      dispatch('fetch-items');
      dispatch('fetch-list');
      ReportService.getItemCounts($report.project, $report.date);
    } catch (error) {
      throw error;
    }
  }
</script>

<div>
  <Row>
    <Col cols={6}>
      <div class="item-info">
        <p class="info">Old Version</p>
        <p class="shared-date">Shared at: {oldItem.reportDate}</p>
      </div>
      <ItemPreview item={oldItem} {categoryConfig} />
    </Col>
    <Col cols={6}>
      <div class="item-info">
        <p class="info">Current Version</p>
        <p class="shared-date">Not shared</p>
      </div>
      <ItemPreview {item} {categoryConfig} />
      <Button
        block
        class="green white-text mt-2 mb-2"
        on:click={() => addReport(item, ItemStatus.REPORT)}>Add to Report</Button
      >
      <Button
        block
        class="grey black-text mt-2 mb-2"
        on:click={() => validatedEvent('update', ItemStatus.DISMISSED)}>Dismiss</Button
      >
    </Col>
  </Row>
</div>

<style lang="scss">
  p {
    margin-bottom: 0;
  }

  :global(.item-info) {
    margin-left: 10px;

    .info {
      font-weight: bold;
      margin-right: 20px;
    }

    .shared-date {
      font-size: 12px;
      color: gray;
      font-weight: 500;
      margin-right: 20px;
    }
  }
</style>
